'use strict';

var MarketProductGroupTDChartSeasonsFilterFactory = function MarketProductGroupTDChartSeasonsFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketProductGroupDateRangeFilterFactory', 'MarketProductGroupMarketFilterFactory', 'MarketProductGroupClassGroupFilterFactory', 'MarketProductGroupDowFilterFactory', 'MarketPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function MarketProductGroupTDChartSeasonsFilter() {
    DemandFilter.call(this, 'market-product-group', 'thematic-demand-chart-market-seasons');
    this.registerFilters(injectedFilters);
  }
  MarketProductGroupTDChartSeasonsFilter.constructor = MarketProductGroupTDChartSeasonsFilter;
  MarketProductGroupTDChartSeasonsFilter.prototype = Object.create(DemandFilter.prototype);
  return MarketProductGroupTDChartSeasonsFilter;
};
MarketProductGroupTDChartSeasonsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = MarketProductGroupTDChartSeasonsFilterFactory;